import axios from "axios";

const ican = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:4000/api"
      : "https://ican-szd-backend.onrender.com/api",
});

export { ican };
